<a *ngIf="numero" class="whatsapp-flotante-btn" [href]="link" target="_blank" rel="noopener" aria-label="Enviar WhatsApp">
  <img src="assets/icons/whatsapp.svg" alt="WhatsApp">
</a>
